import React, {useContext } from "react";
import { PJContext } from "./pj-context"
import {supFractions} from "../helpers";
import CONSTS from "./pj-constants";
import {PJJourneyNav} from "./pj-journey-nav";



function PJOrderConfirmation(props) {
    const { state, dispatch, data } = useContext(PJContext);

    const orderPayment = (paymentRequired) => {
        let formData = {
        };


        fetch("/purchase/CompleteOrder", {
            method: "POST",
            dataType: "JSON",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify(formData)
        })
            .then((resp) => {
                return resp.json()
            })
            .then((result) => {
                switch (result.status) {
                    case 'OK':
                        dispatch({ type: CONSTS.COMPLETE_JOURNEY, data:data});
                        break;
                    case 'ERROR':
                        console.log("Can't save order details");
                        break;
                }

            })
            .catch((error) => {
                console.log(error, "Ajax request error")
            })
    };

    return  (
        <div className={"order-frame journey-step step-7 " + props.current}>
            <div className="frame-content d-flex">
                <div className="order-review order-confirmation my-auto mx-auto">
                    <h4 className="center">YOUR <strong>REV</strong> ORDER</h4>
                    <div className="line-item mx-auto d-flex head-cell">
                        <h2 className="flex-fill" dangerouslySetInnerHTML={{__html: data.title}} />
                        <div className="order-total line-cost" dangerouslySetInnerHTML={{__html: supFractions(state.totalPrice)}} />
                    </div>
                    {(data.type === 'customBundle') &&
                    <div>
                        {data.included.map((included, i) => {
                            return (
                                <div className="line-item mx-auto d-flex" key={included.id}>
                                    <div className="flex-fill" dangerouslySetInnerHTML={{__html: included.title}} />
                                </div>
                            );
                        })}
                        <br />
                    </div>
                    }
                    {Object.keys(state.selectedAddons).map((addonKey, i) => {
                        return (
                            <div className="line-item mx-auto d-flex" key={state.selectedAddons[addonKey].id}>
                                <div className="title flex-fill" dangerouslySetInnerHTML={{__html: state.selectedAddons[addonKey].title}} />
                                <div className="line-cost" dangerouslySetInnerHTML={{__html: supFractions(state.selectedAddons[addonKey].price)}} />
                            </div>
                        );
                    })}
                    {Object.keys(state.standaloneSelected).map((addonKey, i) => {
                        return (
                            <div className="line-item mx-auto d-flex" key={state.standaloneSelected[addonKey].id}>
                                <div className="title flex-fill" dangerouslySetInnerHTML={{__html: state.standaloneSelected[addonKey].title}} />
                                <div className="line-cost" dangerouslySetInnerHTML={{__html: supFractions(state.standaloneSelected[addonKey].price)}} />
                            </div>
                        );
                    })}
                    {state.seasonTickets &&
                        <div className="line-item mx-auto d-flex">
                            <div className="title flex-fill">Find out more about season tickets</div>
                            <div className="line-cost">Yes</div>
                        </div>
                    }
                    <hr className="line-item mx-auto" />
                    <div className={"line-item mx-auto monthly-total d-flex "  + ((state.seasonTotal > 0) && 'has-season-cost')}>
                        <div className="title flex-fill mt-auto">monthly cost</div>
                        <div className="line-cost" dangerouslySetInnerHTML={{__html: supFractions(state.monthlyTotal)}} />
                    </div>
                    {(state.seasonTotal > 0) &&
                    <>
                        <div className="line-item mx-auto monthly-total d-flex">
                            <div className="title flex-fill mt-auto">+ season cost</div>
                            <div className="line-cost" dangerouslySetInnerHTML={{__html: supFractions(state.seasonTotal)}} />
                        </div>
                    </>
                    }
                    {!state.existingCustomer &&
                    <div>
                        <div className="line-item mx-auto d-flex">
                            <div className="title flex-fill">once off installation fee</div>
                            <div className="line-cost" dangerouslySetInnerHTML={{__html: supFractions(data.installationFee)}} />
                        </div>
                        <div className="line-item mx-auto d-flex">
                            <div className="title flex-fill">once off deposit</div>
                            <div className="line-cost" dangerouslySetInnerHTML={{__html: supFractions(data.deposit)}} />
                        </div>
                    </div>
                    }

                    <hr className="line-item mx-auto" />
                    <div className="line-item mx-auto monthly-total order-total d-flex">
                        <div className="title flex-fill mt-auto">Upfront cost</div>
                        <div className="line-cost" dangerouslySetInnerHTML={{__html: supFractions(((state.existingCustomer)?0:(data.installationFee + data.deposit)))}} />
                    </div>
                    <div className="line-item mx-auto d-flex vat-info">
                        <div className="title flex-fill small">* prices exclude VAT</div>
                    </div>
                    <div className="line-item mx-auto d-flex vat-info">
                        <div className="title flex-fill small">Equipment required to receive services – rental fees may apply</div>
                    </div>

                </div>
            </div>

            <PJJourneyNav
                backClick={e => dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_2_ORDER_REVIEW} })}
                continueClick={e => orderPayment(!state.existingCustomer)}
                continueLabel={'Complete order'}
                continueExtra={''}
                continueSize={'6'}
                middleSize={'3'}
            />
        </div>
    );
}

export { PJOrderConfirmation };